const state = () => ({
    navMenus:[
      {
        url: '/home',
        name: 'Home',
      },
      {
        url: '/feature',
        name: 'Features',
      },
      {
        url: '/property-manager-about',
        name: 'Property Manager',
      },
      {
        url: '/owner-details',
        name: 'Owners',
      },
      {
        url: '/residents',
        name: 'Residents',
      },
      {
        url: '/recommend',
        name: 'Recommend',
      },
      {
        url: '/pricing',
        name: 'Pricing',
      },
      {
        url: '/contact',
        name: 'Contact Us',
      },
    ],
    logo:require('~/assets/img/logo 11.png'),
    homeUrl:'/home',
    showManagementLogin:false,
    isMobileMenuOpen: false,
})
export default state
